import React from 'react';
import CreateVideoCategoryState from './createVideoCategoryState/CreateVideoCategoryState';
import ControlPanel from './components/ControlPanel/ControlPanel';
import ModalWindows from './components/ModalWindows/ModalWindows';
import Forms from './components/Forms/Forms';

const CreateVideoCategoryPage: React.FC = () => {
	return (
		<CreateVideoCategoryState>
			<ControlPanel />
			<Forms />
			<ModalWindows />
		</CreateVideoCategoryState>
	);
};

export default CreateVideoCategoryPage;
